import React from 'react';
import { 
    Container, Typography, Paper,
    CardContent,
    Card,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";

export const Article = () => {
  return (
    <>
    {/* 下部説明エリア */}
    <br /><br /><br />
    <Container maxWidth="md">

        {/* 使い方 */}
        <Card sx={{ boxShadow: 3, borderRadius: 4, p: 3, mb: 4 }}>
            <CardContent>
                <Typography variant="h4" component="h1" gutterBottom>Resize Textures の使い方</Typography>
                
                <Typography variant="h6" component="h2" sx={{ mt: 2, mb: 1 }}>📌 ステップ1：画像をアップロード</Typography>
                <Typography variant="body1">
                    「<strong>画像をアップロード</strong>」ボタンをクリックし、リサイズしたい画像を選択します。<br />
                    アップロードした枚数が表示されます。
                </Typography>

                <Typography variant="h6" component="h2" sx={{ mt: 3, mb: 1 }}>⚙️ ステップ2：比率維持orクロップ</Typography>
                <Typography variant="body1">
                    <strong>モード選択：</strong>「比率を維持」または「クロップ」を選択します。<br />
                    クロップ時は起点位置（左上・中央など）も選択可能。<br />
                    <strong>サイズ指定：</strong> 幅と高さを入力（128 ～ 2048 px）。
                </Typography>

                <Typography variant="h6" component="h2" sx={{ mt: 3, mb: 1 }}>🚀 ステップ3：リサイズを実行</Typography>
                <Typography variant="body1">
                    「<strong>リサイズ開始</strong>」ボタンをクリックすると、選択したサイズで画像がリサイズされます。
                </Typography>

                <Typography variant="h6" component="h2" sx={{ mt: 3, mb: 1 }}>💾 ステップ4：ダウンロード</Typography>
                <Typography variant="body1">
                    リサイズ後の画像は個別にダウンロードできます。<br />
                    また、すべての画像を<strong>ZIP形式で一括ダウンロード</strong>することも可能です。
                </Typography>
            </CardContent>
        </Card>

        {/* 処理の流れ */}
        <Card sx={{ boxShadow: 3, borderRadius: 4, p: 3, mb: 4 }}>
            <CardContent>
                <Typography variant="h4" component="h1" gutterBottom>処理の流れ（具体例）</Typography>
                <Typography variant="h6" component="h2" sx={{ mt: 2 }}>📌 例：テクスチャ画像「brick_wall.jpg」をリサイズ</Typography>

                <ol>
                    <li>
                        <strong>① 画像アップロード：</strong>
                        <Typography variant="body1" sx={{ ml: 2, mt: 1 }}>
                            ユーザーが「brick_wall.jpg」（<strong>解像度：4096x2048px</strong>）をアップロードします。
                        </Typography>
                    </li>

                    <li>
                        <strong>② リサイズサイズを選択：</strong>
                        <Typography variant="body1" sx={{ ml: 2, mt: 1 }}>
                            「<strong>1024</strong>」を選択すると、アスペクト比（2:1）を維持して**1024x512px**にリサイズされます。
                        </Typography>
                    </li>

                    <li>
                        <strong>③ リサイズ処理：</strong>
                        <Typography variant="body1" sx={{ ml: 2, mt: 1 }}>
                            `canvas`に画像を描画し、`drawImage()`で**比率を維持したまま縮小**します。
                        </Typography>
                    </li>

                    <li>
                        <strong>④ ファイル名の変更：</strong>
                        <Typography variant="body1" sx={{ ml: 2, mt: 1 }}>
                            リサイズ後のファイル名は以下のように変わります：
                            <ul>
                                <li>オリジナル画像：<code>brick_wall.jpg</code></li>
                                <li>リサイズ後：<code>brick_wall_1024.jpg</code></li>
                                <li>ZIP形式：<code>brick_wall_1024.zip</code></li>
                            </ul>
                        </Typography>
                    </li>

                    <li>
                        <strong>⑤ 一括ダウンロード：</strong>
                        <Typography variant="body1" sx={{ ml: 2, mt: 1 }}>
                            複数のサイズにリサイズした場合は、ZIP形式でまとめてダウンロードできます。
                            <br />
                            <strong>例：</strong> 128, 256, 512, 1024にリサイズすると：
                            <ul>
                                <li><code>brick_wall_128.jpg</code></li>
                                <li><code>brick_wall_256.jpg</code></li>
                                <li><code>brick_wall_512.jpg</code></li>
                                <li><code>brick_wall_1024.jpg</code></li>
                            </ul>
                            → <code>brick_wall_resized.zip</code> にまとめられます。
                        </Typography>
                    </li>
                </ol>
            </CardContent>
        </Card>

        {/* 特徴 */}
        <Card sx={{ boxShadow: 3, borderRadius: 4, p: 3, mb: 4 }}>
            <CardContent>
                <Typography variant="h4" component="h1" gutterBottom>特徴</Typography>
                <ul>
                    <li>✅ フロントエンドのみで処理 → 高速かつ安全</li>
                    <li>✅ アスペクト比を維持したままリサイズ</li>
                    <li>✅ 一括ダウンロードが可能で効率的</li>
                    <li>✅ MUIを使ったモダンで直感的なUI</li>
                </ul>
            </CardContent>
        </Card>

        {/* 利用シーン */}
        <Card sx={{ boxShadow: 3, borderRadius: 4, p: 3, mb: 4 }}>
            <CardContent>
                <Typography variant="h4" component="h1" gutterBottom>利用シーン</Typography>
                <ul>
                    <li>🎯 <strong>Unreal EngineやTwinmotionでのテクスチャ準備</strong></li>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                        ゲームエンジンでは**2の累乗サイズ**のテクスチャが推奨されています。  
                        サイズが揃っていないとエンジン内で変換処理が発生し、**パフォーマンスが低下**します。
                    </Typography>

                    <li>🔧 <strong>3Dモデルの軽量化</strong></li>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                        高解像度テクスチャは品質が高い反面、データ容量が増えます。  
                        リサイズで**軽量化することで読み込み速度が向上**します。
                    </Typography>

                    <li>⚙️ <strong>Web用の軽量画像作成</strong></li>
                    <Typography variant="body1" sx={{ mt: 1 }}>
                        Webアプリで表示する画像は**軽量化することで高速表示**が可能になります。
                    </Typography>
                </ul>
            </CardContent>
        </Card>

        {/* 全パターン網羅のサイズ評価ランキング */}
        <Card sx={{ boxShadow: 3, borderRadius: 4, p: 3, mb: 4 }}>
            <CardContent>
                <Typography variant="h4" component="h1" gutterBottom>画像サイズ評価ランキング</Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    ✅ **PoTサイズ**はGPU処理効率が良く、高速に描画されます。  
                    ⚠️ **非PoTサイズ**は自動で拡張されるため、メモリ浪費とパフォーマンス低下が発生します。
                </Typography>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                        <TableRow>
                                <TableCell><strong>順位</strong></TableCell>
                                <TableCell><strong>サイズ</strong></TableCell>
                                <TableCell><strong>分類</strong></TableCell>
                                <TableCell><strong>拡張サイズ</strong></TableCell>
                                <TableCell><strong>評価</strong></TableCell>
                                <TableCell><strong>点数</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {/* PoTサイズ */}
                            <TableRow>
                                <TableCell>🥇 1位</TableCell>
                                <TableCell>128×128</TableCell>
                                <TableCell>PoT正方形</TableCell>
                                <TableCell>そのまま</TableCell>
                                <TableCell>✅ 最適</TableCell>
                                <TableCell>⭐️⭐️⭐️⭐️⭐️（5点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>🥈 2位</TableCell>
                                <TableCell>256×256</TableCell>
                                <TableCell>PoT正方形</TableCell>
                                <TableCell>そのまま</TableCell>
                                <TableCell>✅ 最適</TableCell>
                                <TableCell>⭐️⭐️⭐️⭐️⭐️（5点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>🥉 3位</TableCell>
                                <TableCell>512×512</TableCell>
                                <TableCell>PoT正方形</TableCell>
                                <TableCell>そのまま</TableCell>
                                <TableCell>✅ 最適</TableCell>
                                <TableCell>⭐️⭐️⭐️⭐️⭐️（5点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>4位</TableCell>
                                <TableCell>128×512</TableCell>
                                <TableCell>PoT長方形</TableCell>
                                <TableCell>そのまま</TableCell>
                                <TableCell>✅ 高評価</TableCell>
                                <TableCell>⭐️⭐️⭐️⭐️（4点）</TableCell>
                            </TableRow>

                            {/* 非PoTサイズ */}
                            <TableRow>
                                <TableCell>5位</TableCell>
                                <TableCell>320×320</TableCell>
                                <TableCell>非PoT正方形</TableCell>
                                <TableCell>512×512</TableCell>
                                <TableCell>⚠️ 中評価</TableCell>
                                <TableCell>⭐️⭐️⭐️（3点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>6位</TableCell>
                                <TableCell>128×90</TableCell>
                                <TableCell>非PoT長方形</TableCell>
                                <TableCell>128×128</TableCell>
                                <TableCell>⚠️ 中評価</TableCell>
                                <TableCell>⭐️⭐️⭐️（3点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>7位</TableCell>
                                <TableCell>300×100</TableCell>
                                <TableCell>非PoT長方形</TableCell>
                                <TableCell>512×128</TableCell>
                                <TableCell>❌ 低評価</TableCell>
                                <TableCell>⭐️⭐️（2点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>8位</TableCell>
                                <TableCell>640×360</TableCell>
                                <TableCell>非PoT長方形</TableCell>
                                <TableCell>1024×512</TableCell>
                                <TableCell>❌ 低評価</TableCell>
                                <TableCell>⭐️⭐️（2点）</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>9位</TableCell>
                                <TableCell>1920×1080</TableCell>
                                <TableCell>非PoT長方形</TableCell>
                                <TableCell>2048×2048</TableCell>
                                <TableCell>❌ 低評価</TableCell>
                                <TableCell>⭐️（1点）</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    </Container>
    </>
  );
};
